export const LIST = 'LIST';
export const EDIT = 'EDIT';
export const ADD = 'ADD';
export const ACTIVATION = 'ACTIVATION';
